import { LOGIN, LOGOUT } from '../actions/types';

const INITIAL_STATE = {
	givenName: '',
	surname: '',
	name: '',
	email: '',
	jobTitle: '',
	photo: '',
	role: '',
	officeLocation: '',
	authenticated: false
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case LOGIN:
			return {
				...state,
				[action.payload.prop]: action.payload.value
			};
		case LOGOUT:
			return INITIAL_STATE;
		default:
			return state;
	}
};
